(() => {
  'use strict';

  // Collection cards are normal links rendered by Liquid. This script only
  // removes invalid same-page/hash destinations left by old theme settings.
  const isRealCollectionUrl = (value) => {
    if (!value) return false;
    try {
      const url = new URL(value, window.location.origin);
      return /^\/collections\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname) &&
        !/^\/collections\/(all|pet-boutique|more-than-pet-boutique|more-than-a-pet-boutique)\/?$/i.test(url.pathname);
    } catch (_) {
      return false;
    }
  };

  const validate = (root = document) => {
    root.querySelectorAll?.('a[data-stoney-collection-card]').forEach((card) => {
      const href = card.getAttribute('href') || '';
      if (!isRealCollectionUrl(href)) {
        card.removeAttribute('href');
        card.setAttribute('aria-disabled', 'true');
      }
    });
  };

  const start = () => {
    validate(document);
    new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) validate(node);
      }));
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
